import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SortingState } from '@tanstack/react-table'

import {
  ClientFiltersState,
  INITIAL_FILTER_STATE,
} from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/clientFilters/ClientFiltersPopover'

type Scope = {
  id: string
  encryptionKey: string
}
type UserSettingsState = {
  lastConversationClientId?: string
  clientListFilters: ClientFiltersState
  clientListSorting: SortingState
  scope?: Scope
}

const initialState: UserSettingsState = {
  clientListFilters: INITIAL_FILTER_STATE,
  clientListSorting: [{ id: 'nextAppointment', desc: false }],
}

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    setLastConversationClientId: (state, action: PayloadAction<string | undefined>) => {
      state.lastConversationClientId = action.payload
    },
    setClientListFilters: (state, action: PayloadAction<ClientFiltersState>) => {
      state.clientListFilters = action.payload
    },
    setClientListSorting: (state, action: PayloadAction<SortingState>) => {
      state.clientListSorting = action.payload
    },
    setScope: (state, action: PayloadAction<Scope | undefined>) => {
      state.scope = action.payload
    },
  },
})

export const { setLastConversationClientId, setClientListFilters, setClientListSorting, setScope } =
  userSettingsSlice.actions
export default userSettingsSlice.reducer
